module.exports = __webpack_public_path__ + "img/日常检测.7525ed82.svg";